







































































import { Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';

import { required } from 'vuelidate/lib/validators';
import { formMixin } from '~/utils/form';

import BaseModal from '~/components/modals/BaseModal.vue';
import AreaInput from '~/components/inputs/AreaInput.vue';
import SinglePicker from '~/components/lists/SinglePicker.vue';
import ProfileRunEditPhotos from '~/components/partials/ProfileRunEditPhotos.vue';

@Component({
  components: { BaseModal, AreaInput, SinglePicker, ProfileRunEditPhotos },
  validations: {
    areaText: { required },
  },
})
export default class ReportModal extends mixins(formMixin) {
  @Prop(String) title: '{ No title }';
  @Prop(String) description: '{ No description }';
  @Prop(String) cancelLabel: '';
  @Prop(String) confirmLabel: '';
  @Prop(String) isConnected: '';

  selectedTag: string = '';
  areaText: string = '';
  submittedPictures: Array<string> = [];
  hasSubmitted: boolean = false;

  tags: Array<{id: string, name: string, checked: boolean}> = [
    { id: 'state', name: this.$t('reportModal.options.state'), checked: false },
    { id: 'points', name: this.$t('reportModal.options.points'), checked: false },
    { id: 'guidance', name: this.$t('reportModal.options.guidance'), checked: false },
    { id: 'app', name: this.$t('reportModal.options.app'), checked: false },
    { id: 'other', name: this.$t('reportModal.options.other'), checked: false },
  ];

  /* When user submits a picture from input, add it to this.submittedPictures */
  handleUploadedPictures (val: string) {
    this.submittedPictures.push(val);
  }

  /*
    When user submits a picture from input, remove it
    from this.submittedPictures
  */
  deleteUploadedPicture (val: number) {
    this.submittedPictures.splice(val, 1);
  }

  /* Emits a submit event to parent to prepare for API actions */
  submit () {
    this.formMixin_handleSubmit(() => {
      this.hasSubmitted = true;
      this.$emit('confirm-action', {
        category: this.selectedTag,
        text: this.areaText,
        media: this.submittedPictures,
      });
    });
  }
};
